import {
  CoworkingExpenseCategoryModel,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class CoworkingExpenseCategoryService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  getList(options: IRequestOptions = {}): Promise<CoworkingExpenseCategoryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingExpenseCategory/GetList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
